// extracted by mini-css-extract-plugin
export default {"box":"checkbox_box__1vDy7","checkbox":"checkbox_checkbox__9XLjP"};